
<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb  [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="my-0" >Upcoming Events</h2>
    <!-- <button nz-button nzType="primary">Add User</button> -->
  </div>
</nz-card>


<nz-card class="!my-4">
  <div class="flex justify-start  xsm:items-center gap-3 max-w-[600px] w-[100%] flex-col xsm:flex-row">
    <div class=" flex justify-start items-center basis-[70%] sm:basis-[80%]">

      <nz-input-group nzSearch nzSize="large" [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton"
                      style="max-width: 500px">
        <input type="text" nz-input placeholder="Search Events" [(ngModel)]="searchValue"/>
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" (click)="getEventsBySearch()" nzSearch><span nz-icon nzType="search"></span>Search
        </button>
      </ng-template>
      <ng-template #inputClearTpl>
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="searchValue"
            (click)="cancelSearch()"
          ></span>
      </ng-template>
    </div>
    <div class="h-[40px] w-full  basis-[30%]">
      <nz-date-picker class="h-full w-full" [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
    </div>
  </div>
</nz-card>
<nz-empty class="mt-10" *ngIf="this.data.length === 0"></nz-empty>
<div class="grid-container w-full items-start">
  <div class="bg-white px-3 2xl:px-5 rounded-md relative py-5 h-full" *ngFor="let event of data">

    <div class="flex justify-between items-start gap-5 relative flex-col xl:flex-row">
      <div class="basis-[40%] h-[150px] xl:h-[300px]  w-full">
        <img class="w-full rounded-lg h-full object-cover" alt="image" (error)="onImageError($event)"
             [src]="event.thumbnail?.url || ''"/>
      </div>
      <div class="basis-[60%]  w-full ">
        <h4 class="text-[#2F5EA4] clickable-text xl:mt-10"
            (click)="viewEvent(this.event.id)">{{event.name}}</h4>
        <div class="my-3">
          <p class="flex justify-start gap-2 items-center mb-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
              stroke="rgba(45, 38, 75, 0.25)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-map-pin">
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <span class="font-semibold">{{event.venue}}</span></p>
          <p class="flex justify-start gap-2 items-center">
            <svg width="17" height="17" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.25955 12.9271L2.69509 12.3165L2.25955 12.9271ZM1.58356 12.2634L2.18644 11.8172L1.58356 12.2634ZM11.4164 12.2634L10.8136 11.8172L11.4164 12.2634ZM10.7405 12.9271L11.176 13.5376L10.7405 12.9271ZM10.7405 3.27295L11.176 2.66237L10.7405 3.27295ZM11.4164 3.93664L10.8136 4.38278L11.4164 3.93664ZM2.25955 3.27295L2.69509 3.88352L2.69509 3.88352L2.25955 3.27295ZM1.58356 3.93664L2.18644 4.38278V4.38278L1.58356 3.93664ZM10.9109 9.93694L10.7957 9.19584L10.9109 9.93694ZM8.37095 12.4307L7.63052 12.3113L8.37095 12.4307ZM4.66667 7.95C4.25245 7.95 3.91667 8.28579 3.91667 8.7C3.91667 9.11421 4.25245 9.45 4.66667 9.45V7.95ZM8.33333 9.45C8.74755 9.45 9.08333 9.11421 9.08333 8.7C9.08333 8.28579 8.74755 7.95 8.33333 7.95V9.45ZM7.58333 3.3C7.58333 3.71421 7.91912 4.05 8.33333 4.05C8.74755 4.05 9.08333 3.71421 9.08333 3.3H7.58333ZM9.08333 1.5C9.08333 1.08579 8.74755 0.75 8.33333 0.75C7.91912 0.75 7.58333 1.08579 7.58333 1.5H9.08333ZM3.91667 3.3C3.91667 3.71421 4.25245 4.05 4.66667 4.05C5.08088 4.05 5.41667 3.71421 5.41667 3.3H3.91667ZM5.41667 1.5C5.41667 1.08579 5.08088 0.75 4.66667 0.75C4.25245 0.75 3.91667 1.08579 3.91667 1.5H5.41667ZM11.9823 9.9L12.7319 9.92616L11.9823 9.9ZM1.01768 6.3L0.268135 6.27384L1.01768 6.3ZM11.9823 6.3L12.7319 6.27384L11.9823 6.3ZM6.5 12.75C5.33784 12.75 4.52538 12.749 3.90099 12.6826C3.28984 12.6176 2.94812 12.497 2.69509 12.3165L1.824 13.5376C2.37417 13.9301 3.00692 14.0959 3.74233 14.1742C4.46449 14.251 5.37066 14.25 6.5 14.25V12.75ZM0.25 8.1C0.25 9.20791 0.248933 10.1002 0.32747 10.8119C0.407648 11.5385 0.578122 12.1655 0.980677 12.7095L2.18644 11.8172C2.00544 11.5726 1.88413 11.2429 1.81842 10.6474C1.75107 10.037 1.75 9.24193 1.75 8.1H0.25ZM2.69509 12.3165C2.49938 12.1769 2.32783 12.0083 2.18644 11.8172L0.980677 12.7095C1.21622 13.0278 1.50091 13.3072 1.824 13.5376L2.69509 12.3165ZM10.8136 11.8172C10.6722 12.0083 10.5006 12.1769 10.3049 12.3165L11.176 13.5376C11.4991 13.3072 11.7838 13.0278 12.0193 12.7095L10.8136 11.8172ZM10.3049 3.88352C10.5006 4.02313 10.6722 4.19171 10.8136 4.38278L12.0193 3.49051C11.7838 3.17221 11.4991 2.89284 11.176 2.66237L10.3049 3.88352ZM1.824 2.66237C1.50091 2.89285 1.21622 3.17221 0.980677 3.49051L2.18644 4.38278C2.32783 4.19171 2.49938 4.02313 2.69509 3.88352L1.824 2.66237ZM10.7957 9.19584C9.17493 9.44787 7.89059 10.6991 7.63052 12.3113L9.11138 12.5501C9.26547 11.5949 10.032 10.8326 11.0261 10.678L10.7957 9.19584ZM4.66667 9.45H8.33333V7.95H4.66667V9.45ZM11.9823 9.15C11.4534 9.15 11.1022 9.14818 10.7957 9.19584L11.0261 10.678C11.1897 10.6526 11.3994 10.65 11.9823 10.65L11.9823 9.15ZM11.25 8.1C11.25 8.80558 11.2499 9.3831 11.2328 9.87384L12.7319 9.92616C12.7501 9.40368 12.75 8.79713 12.75 8.1H11.25ZM11.2328 9.87384C11.1941 10.982 11.067 11.4747 10.8136 11.8172L12.0193 12.7095C12.5691 11.9665 12.6925 11.055 12.7319 9.92616L11.2328 9.87384ZM9.08333 13.4826C9.08334 12.9088 9.0861 12.7069 9.11138 12.5501L7.63052 12.3113C7.58136 12.6161 7.58334 12.9648 7.58333 13.4826L9.08333 13.4826ZM6.5 14.25C7.21027 14.25 7.82726 14.2501 8.35855 14.2322L8.30812 12.7331C7.80743 12.7499 7.21842 12.75 6.5 12.75V14.25ZM8.35855 14.2322C9.50599 14.1936 10.4253 14.0731 11.176 13.5376L10.3049 12.3165C9.94993 12.5697 9.43912 12.695 8.30812 12.7331L8.35855 14.2322ZM1.75 8.1C1.75 7.39442 1.7501 6.8169 1.76722 6.32616L0.268135 6.27384C0.249903 6.79632 0.25 7.40287 0.25 8.1H1.75ZM1.76722 6.32616C1.80589 5.218 1.93296 4.72532 2.18644 4.38278L0.980677 3.49051C0.430874 4.23349 0.307527 5.14498 0.268135 6.27384L1.76722 6.32616ZM1.01768 7.05H11.9823V5.55H1.01768V7.05ZM12.75 8.1C12.75 7.40287 12.7501 6.79632 12.7319 6.27384L11.2328 6.32616C11.2499 6.8169 11.25 7.39442 11.25 8.1H12.75ZM12.7319 6.27384C12.6925 5.14498 12.5691 4.23349 12.0193 3.49051L10.8136 4.38278C11.067 4.72532 11.1941 5.218 11.2328 6.32616L12.7319 6.27384ZM9.08333 3.3V2.71736H7.58333V3.3H9.08333ZM9.08333 2.71736V1.5H7.58333V2.71736H9.08333ZM6.5 3.45C7.21842 3.45 7.80743 3.45009 8.30812 3.46693L8.35855 1.96778C7.82726 1.94991 7.21027 1.95 6.5 1.95V3.45ZM8.30812 3.46693C9.43912 3.50498 9.94993 3.63031 10.3049 3.88352L11.176 2.66237C10.4253 2.12691 9.50599 2.00638 8.35855 1.96778L8.30812 3.46693ZM5.41667 3.3V2.71736H3.91667V3.3H5.41667ZM5.41667 2.71736V1.5H3.91667V2.71736H5.41667ZM6.5 1.95C5.78973 1.95 5.17274 1.94991 4.64145 1.96778L4.69188 3.46693C5.19257 3.45009 5.78158 3.45 6.5 3.45V1.95ZM4.64145 1.96778C3.49401 2.00638 2.57465 2.12691 1.824 2.66237L2.69509 3.88352C3.05007 3.63031 3.56088 3.50498 4.69188 3.46693L4.64145 1.96778Z" fill="#2D264B" fill-opacity="0.25"/>
            </svg>
            <span class="font-semibold">{{formatDate(event.startTime, event.endTime)}}</span>
          </p>
        </div>
        <p class="mt-3 text-[#706D6D] font-[400] ">{{this.event.excerpt}}</p>




        <div *ngIf="event.link && showLink() && isExpired(event.endTime)">
          <a [href]="event.link" nz-button class="add-post-btn font-medium" target="_blank">
            Join Webinar
          </a>
        </div>

        <!-- RSVP Buttons for all events -->
        <div *ngIf="!hasRSVPResponse(event)" class="flex gap-2 mt-3">
          <button
            nz-button 
            class="add-post-btn font-medium text-sm"
            (click)="addParticipant('WillAttend', event)"
            [nzLoading]="false">
            I Will Attend
          </button>
          <button
            nz-button 
            class="bg-gray-500 hover:bg-gray-600 text-white font-medium px-3 py-1 text-sm rounded"
            (click)="addParticipant('WillNotAttend', event)"
            [nzLoading]="false">
            I Will Not Attend
          </button>
        </div>
        
        <!-- Show current RSVP status if user has responded -->
        <div *ngIf="hasRSVPResponse(event)" class="mt-3">
          <p *ngIf="getRSVPResponse(event) === 'willAttend'" class="text-green-600 text-sm font-medium">
            ✓ You responded: I will attend
          </p>
          <p *ngIf="getRSVPResponse(event) === 'willNotAttend'" class="text-gray-600 text-sm font-medium">
            ✓ You responded: I will not attend
          </p>
        </div>

        <ng-template #titleTemplateRegister>
          <h3 *ngIf="event.eventType === 'Registration'">Registration</h3>
          <h3 *ngIf="event.eventType === 'Open'">Open Event Confirmation</h3>
        </ng-template>

        <ng-template #contentRegisterTemplate>
          <div class="p-4">
            <p class="font-medium text-xl" *ngIf="event.eventType === 'Open'">Attending: {{event.name}}?</p>
            <p class="font-medium text-xl" *ngIf="event.eventType === 'Registration'">Register for {{event.name}}?</p>
            <div class="flex gap-2 justify-center mt-4">
              <button nz-button nzType="primary" *ngIf="event.eventType === 'Registration'"
              (click)="showModalAttendence(this.event)">Register
              </button>
              <button nz-button nzType="primary" *ngIf="event.eventType === 'Open'"
                      (click)="addParticipant('Add',event)">Confirm Attendance
              </button>
            </div>

          </div>
        </ng-template>

      </div>
    </div>
  </div>

</div>


<nz-modal [(nzVisible)]="isVisibleForm" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="null" (nzOnCancel)="handleCancel()">
  <ng-template #modalTitle>
    <ng-container>
      Attendance Form
    </ng-container>
  </ng-template>

  <ng-template #modalContent>
    <ng-container>
      <form nz-form [formGroup]="attendanceForm">
        <div class="flex flex-col gap-4">
          <div class="w-full">
            <p class="font-normal mb-0">Name of the Judge (Readonly)</p>
            <nz-form-item>
              <nz-form-control nzErrorTip="Name is required" class="w-full">
                <nz-input-group>
                  <input
                    type="text"
                    nz-input
                    formControlName="name"
                    [placeholder]="this.loggedUser.name"
                    readonly
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>
      
          <div class="flex lg:flex-row flex-col lg:gap-3">
            <div class="lg:w-1/2 w-full">
              <p class="font-normal mb-0">Designation</p>
              <nz-form-item>
                <nz-form-control nzErrorTip="Enter Designation" class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="designation" placeholder="Enter Designation" />
                  </nz-input-group>
                  <div *ngIf="getFormControl('designation')!.invalid && (getFormControl('designation')!.dirty || getFormControl('designation')!.touched)">
                    <small *ngIf="getFormControl('designation')!.errors?.['required']" class="text-red-500">Designation is required</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="lg:w-1/2 w-full">
              <p class="font-normal mb-0">Station</p>
              <nz-form-item>
                <nz-form-control nzErrorTip="Enter Station" class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="station" placeholder="Enter Station" />
                  </nz-input-group>
                  <div *ngIf="getFormControl('station')!.invalid && (getFormControl('station')!.dirty || getFormControl('station')!.touched)">
                    <small *ngIf="getFormControl('station')!.errors?.['required']" class="text-red-500">Station is required</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
      
          <div class="w-full">
            <p class="font-normal mb-0">No of Accompanying Persons (Adults)</p>
            <nz-form-item>
              <nz-form-control nzErrorTip="Count is required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="adultCount" placeholder="Enter Numeric Value" />
                </nz-input-group>
                <div *ngIf="getFormControl('adultCount')!.invalid && (getFormControl('adultCount')!.dirty || getFormControl('adultCount')!.touched)">
                  <small *ngIf="getFormControl('adultCount')!.errors?.['required']" class="text-red-500">Adult count is required</small>
                  <small *ngIf="getFormControl('adultCount')!.errors?.['pattern']" class="text-red-500">Must be a numeric value</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
      
          <div class="w-full">
            <p class="font-normal mb-0">No of Accompanying Children with their Age</p>
            <div class="flex lg:flex-row flex-col lg:gap-3">
              <nz-form-item class="mb-3 lg:w-1/2">
                <nz-form-control nzErrorTip="Children count is required" class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="childrenCount" placeholder="Enter 0 if there are no children" />
                  </nz-input-group>
                  <div *ngIf="getFormControl('childrenCount')!.invalid && (getFormControl('childrenCount')!.dirty || getFormControl('childrenCount')!.touched)">
                    <small *ngIf="getFormControl('childrenCount')!.errors?.['required']" class="text-red-500">Children count is required</small>
                    <small *ngIf="getFormControl('childrenCount')!.errors?.['pattern']" class="text-red-500">Must be a numeric value</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item class="mb-3 lg:w-1/2">
                <nz-form-control class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="childrenAge" placeholder="Eg: 1,5,9" />
                  </nz-input-group>
                  <div *ngIf="getFormControl('childrenAge')!.invalid && (getFormControl('childrenAge')!.dirty || getFormControl('childrenAge')!.touched)">
                    <small *ngIf="getFormControl('childrenAge')!.errors?.['required']" class="text-red-500">Children age is required</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
      
          <div class="w-full">
            <p class="font-normal mb-0">Room Type</p>
            <nz-form-item class="mb-3">
              <nz-form-control nzErrorTip="Room Type required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="roomType" placeholder="Double/Triple or other - specify" />
                </nz-input-group>
                <div *ngIf="getFormControl('roomType')!.invalid && (getFormControl('roomType')!.dirty || getFormControl('roomType')!.touched)">
                  <small *ngIf="getFormControl('roomType')!.errors?.['required']" class="text-red-500">Room type is required</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
      
          <div class="w-full">
            <p class="font-normal mb-0">Expected Dates of Stay</p>
            <nz-form-item class="mb-3">
              <nz-form-control nzErrorTip="Dates are required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="datesOfStay" placeholder="Enter Dates" />
                </nz-input-group>
                <div *ngIf="getFormControl('datesOfStay')!.invalid && (getFormControl('datesOfStay')!.dirty || getFormControl('datesOfStay')!.touched)">
                  <small *ngIf="getFormControl('datesOfStay')!.errors?.['required']" class="text-red-500">Dates of stay are required</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
      
          <div class="flex justify-end">
            <button nz-button nzType="primary" [disabled]="attendanceForm.invalid" (click)="handleAttendanceFormSubmit()">
              Confirm Attendance
            </button>
          </div>
        </div>
      </form>
      
    </ng-container>
  </ng-template>
</nz-modal>

<!-- Reason Modal -->
<nz-modal 
  [(nzVisible)]="isReasonModalVisible" 
  nzTitle="Reason for Not Attending" 
  [nzFooter]="null"
  [nzWidth]="600"
  (nzOnCancel)="handleCancel()"
  nzClosable="true">
  <div *nzModalContent>
    <div class="mb-4">
      <p class="text-gray-600 mb-4">Please provide a reason for not attending this event. This information will be recorded and visible to event organizers.</p>
    </div>
    <form nz-form [formGroup]="reasonForm">
      
        <nz-form-control nzErrorTip="Reason is required" [nzHasFeedback]="true">
          <textarea 
            nz-input 
            formControlName="reason" 
            rows="6" 
            placeholder="Enter your reason here..."
            class="w-full"
            style="min-height: 120px; resize: vertical;">
          </textarea>
        </nz-form-control>
      
      <div class="flex justify-end gap-3 mt-6 pt-4 border-t">
        <button 
          nz-button 
          (click)="handleCancel()"
          class="px-6">
          Cancel
        </button>
        <button 
          nz-button 
          nzType="primary" 
          [disabled]="reasonForm.invalid || reasonForm.get('reason')?.value?.trim() === ''" 
          (click)="handleReasonSubmit()"
          class="px-6">
          Submit
        </button>
      </div>
    </form>
  </div>
</nz-modal>
